import axios from 'axios';
import apiConfig from '../../api.config';

export default async function saveS3Users({
  hotelId,
  chainId,
  sshKey,
  password,
  email,
  name,
  lang,
  ips,
}) {
  const {
    host,
    URIs: { saveS3Users },
  } = apiConfig;

  const uri = `${host}${saveS3Users}`;
  const data = {
    hotelId,
    chainId,
    sshKey,
    password,
    email,
    name,
    lang,
    ips,
  };

  return await axios
    .post(uri, data, {
      headers: { 'Content-Type': 'application/json' },
    })
    .then(res => res.data);
}
